// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ids-empty-message {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 310px;
}
.ids-empty-message .button {
  margin-block-end: var(--ids-empty-message-button-margin-block-end);
}
.ids-empty-message .icon {
  fill: var(--ids-empty-message-color-icon-fill);
  color: var(--ids-empty-message-icon-color);
  margin: var(--ids-empty-message-icon-margin);
  height: var(--ids-empty-message-icon-height);
  width: var(--ids-empty-message-icon-width);
}
.ids-empty-message .label {
  padding: var(--ids-empty-message-label-padding);
}
.ids-empty-message .label ::slotted(span) {
  font-size: var(--ids-empty-message-label-font-size);
}
.ids-empty-message .description {
  padding: var(--ids-empty-message-description-padding);
  text-align: var(--ids-empty-message-description-font-align);
}
@media all and (max-width: 600px) {
  .ids-empty-message {
    margin-left: auto;
    margin-right: auto;
    max-width: 300px;
  }
}
@media all and (max-width: 320px) {
  .ids-empty-message {
    max-width: 220px;
  }
  .ids-empty-message .label {
    text-align: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ids-empty-message/ids-empty-message.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AADF;AAGE;EACE,kEAAA;AADJ;AAIE;EACE,8CAAA;EACA,0CAAA;EACA,4CAAA;EACA,4CAAA;EACA,0CAAA;AAFJ;AAKE;EACE,+CAAA;AAHJ;AAKI;EACE,mDAAA;AAHN;AAOE;EACE,qDAAA;EACA,2DAAA;AALJ;AAQE;EAhCF;IAiCI,iBAAA;IACA,kBAAA;IACA,gBAAA;EALF;AACF;AAOE;EAtCF;IAuCI,gBAAA;EAJF;EAME;IACE,kBAAA;EAJJ;AACF","sourcesContent":["@use '../../themes/mixins/ids-core-mixins' as *;\n\n.ids-empty-message {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 310px;\n\n  .button {\n    margin-block-end: var(--ids-empty-message-button-margin-block-end);\n  }\n\n  .icon {\n    fill: var(--ids-empty-message-color-icon-fill);\n    color: var(--ids-empty-message-icon-color);\n    margin: var(--ids-empty-message-icon-margin);\n    height: var(--ids-empty-message-icon-height);\n    width: var(--ids-empty-message-icon-width);\n  }\n\n  .label {\n    padding: var(--ids-empty-message-label-padding);\n\n    ::slotted(span) {\n      font-size: var(--ids-empty-message-label-font-size);\n    }\n  }\n\n  .description {\n    padding: var(--ids-empty-message-description-padding);\n    text-align: var(--ids-empty-message-description-font-align);\n  }\n\n  @media all and (max-width: $breakpoint-sm) {\n    margin-left: auto;\n    margin-right: auto;\n    max-width: $breakpoint-xs - 20px;\n  }\n\n  @media all and (max-width: $breakpoint-xs) {\n    max-width: $breakpoint-xs - 100px;\n\n    .label {\n      text-align: center;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
